import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  categoryName: string;
  categorySlug: string;
  rating: number;
  views: number;
  chapters: number;
  status: string;
  updatedAt: string;
  tags?: string[];
}

function formatViews(views: number): string {
  if (views >= 1000000) {
    return `${(views / 1000000).toFixed(1)}万`;
  }
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return views.toString();
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  categoryName,
  categorySlug,
  rating,
  views,
  chapters,
  status,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          title={`${title} - 汗汗漫画`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-3 left-3 right-3">
            <span className="inline-block px-2 py-0.5 rounded-full bg-background-50/90 text-xs text-foreground-900 font-medium">
              {status}
            </span>
            <span className="inline-block ml-2 px-2 py-0.5 rounded-full bg-accent-500/90 text-xs text-background-50 font-medium">
              {rating}分
            </span>
          </div>
        </div>
        <div className="absolute top-2 right-2">
          <span className="inline-block px-2 py-0.5 rounded-full bg-primary-500 text-xs text-background-50 font-medium">
            {categoryName}
          </span>
        </div>
        {status === '连载中' && (
          <div className="absolute top-2 left-2">
            <span className="inline-block w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
          </div>
        )}
      </div>

      <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
        {title}
      </h3>

      <div className="flex items-center justify-between mt-1.5">
        <span className="text-xs text-foreground-500">{author}</span>
        <div className="flex items-center gap-2 text-xs text-foreground-400">
          <span className="flex items-center gap-0.5">
            <i className="ri-eye-line text-xs"></i>
            {formatViews(views)}
          </span>
          <span>
            共{chapters}话
          </span>
        </div>
      </div>
    </Link>
  );
}